// extracted by mini-css-extract-plugin
export var dropdownIcon = "_r0-6";
export var imgContainer = "_r0-3";
export var menuIcon = "_r0-5";
export var pillWrapper = "_r0-2";
export var pillsContainer = "_r0-1";
export var subscriptionCard = "_r0-0";
export var subscriptionLogo = "_r0-4";